(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
  $('.collapsable-content-section').click(function () {
    if ($(this).find('.faq-icon').text() == '+') {
      $(this).find('.faq-icon').text('-');
    } else {
      $(this).find('.faq-icon').text('+');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
